import { useField } from 'formik';
import * as React from 'react';

import styles from '../forms.module.css';
import { Label } from '../Label';

interface DateProps {
    label: string;
    id: string;
    name: string;
    required?: boolean;
    fullWidth?: boolean;
    matchInput?: boolean;
    min?: string;
    max?: string;
    readonly?: boolean;
    tooltip?: string;
}

const Date: React.FC<DateProps> = ({
    id,
    label,
    required = false,
    fullWidth = false,
    matchInput = false,
    min,
    max,
    readonly = false,
    ...props
}) => {
    const [field, meta] = useField(props as any);

    return (
        <>
            <Label label={label} id={id} required={required} tooltip={props.tooltip} />
            <input
                className={styles.InputElement}
                type="date"
                min={min}
                max={max}
                style={{
                    width: fullWidth ? '100%' : 'auto',
                    padding: matchInput ? '0.6rem 0.5rem' : '0.75rem 0.5rem',
                }}
                {...field}
                data-qa={`form-input-date-${id}`}
                disabled={readonly}
            />
            {meta.touched && meta.error && (
                <div className={styles.Error}>
                    <span>{meta.error}</span>
                </div>
            )}
        </>
    );
};

export default Date;
